export default {
    // host: 'https://vet-green.store/api/'
    // host: 'https://darkgreen-reindeer-611115.hostingersite.com/api/'
    // host: 'http://localhost/sskkm_v2/'
    host: 'https://goizha-vethospital.online/api/'
}